import { readChallengeSharePath } from '@/routes/challenges/sharing/challengeSharePath'
import { useAppStore } from '@runtime/core/store/appStore'
import { installHistoryTraversalGuard } from '@/core/navigation/historyTraversalGuard'
import * as ReactDOM from 'react-dom/client'

import { BrowserRouter } from 'react-router-dom'

import '@runtime/app/app.scss'

import { I18nProvider } from '@runtime/core/i18n/i18n'
import { applyRequestedLocale } from '@runtime/core/i18n/applyRequestedLocale'
import { UserProvider } from '@runtime/core/user/userContext'
import { startThemeSync } from '@runtime/core/theme/themeSync'

import { disableDevelopmentWorker } from '@/core/pwa/disableDevelopmentWorker'
import App from '@/app/App'
import PlayErrorBoundary from '@/core/resilience/PlayErrorBoundary'
import { isHomeArrivalPath } from '@/routes/home/arrival/homeArrival'
import OnlineMediaSessionProvider from '@/shared/realtime/media/session/OnlineMediaSessionProvider'

// Disable only this development worker; retained caches belong to installed builds.
if (import.meta.env.DEV) {
  void disableDevelopmentWorker().catch(error =>
    console.warn('[pwa] Development worker cleanup unavailable:', error),
  )
}

applyRequestedLocale()
const sharedArrival = readChallengeSharePath(window.location.pathname)
if (sharedArrival) useAppStore.getState().setLocale(sharedArrival.locale)
startThemeSync({ shouldRestore: () => !isHomeArrivalPath(window.location.pathname) })

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

installHistoryTraversalGuard()

ReactDOM.createRoot(rootElement).render(
  <I18nProvider>
    <UserProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <PlayErrorBoundary>
          <OnlineMediaSessionProvider>
            <App />
          </OnlineMediaSessionProvider>
        </PlayErrorBoundary>
      </BrowserRouter>
    </UserProvider>
  </I18nProvider>,
)
